"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PageController = /*#__PURE__*/function () {
  function PageController() {
    _classCallCheck(this, PageController);

    this.body = document.getElementsByTagName("body")[0];
    this.footer = document.getElementById("global-footer");
    this.content = document.getElementById("content");
    this.template = $('body').data('template');
    this.device = $('html').attr('data-device'); //this.mobileMenu = new MobileMenu();

    this.arrayUtils = new ArrayUtils();
    this.dateUtils = new DateUtils();
    this.numberUtils = new NumberUtils();
    this.stringUtils = new StringUtils();
    this.mobileMenu = new MobileMenu();
  }

  _createClass(PageController, [{
    key: "isLoadedFromMobile",
    value: function isLoadedFromMobile() {
      return this.device === "phone";
    }
  }, {
    key: "isLoadedFromTablet",
    value: function isLoadedFromTablet() {
      return this.device === "tablet";
    }
  }]);

  return PageController;
}();